import React from 'react';

interface SectionHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  subtitleColor?: 'default' | 'primary' | 'secondary' | 'tertiary' | 'muted' | 'white' | 'slate';
  align?: 'left' | 'center';
  className?: string;
  inverted?: boolean;
  subtitleTag?: 'p' | 'h3';
  titleTag?: 'h1' | 'h2' | 'h3';
}

// eslint-disable-next-line import/prefer-default-export
export function SectionHeader({
  title,
  subtitle,
  subtitleColor = 'default',
  align = 'center',
  className = '',
  inverted = false,
  subtitleTag = 'p',
  titleTag = 'h2',
}: SectionHeaderProps) {
  const alignClass = align === 'center' ? 'text-center mx-auto' : 'text-left';
  const textClass = inverted ? 'text-white' : 'text-slate-900';

  const colorMap = {
    default: inverted ? 'text-white/90' : 'text-slate-600',
    primary: 'text-primary',
    secondary: 'text-secondary',
    tertiary: 'text-tertiary',
    muted: 'text-muted',
    white: 'text-white',
    slate: 'text-slate-600',
  };

  const subtitleColorClass = colorMap[subtitleColor] || colorMap.default;

  const SubtitleTag = subtitleTag;
  const TitleTag = titleTag;

  return (
    <div className={`max-w-3xl ${alignClass} mb-16 ${className}`}>
      <TitleTag className={`${textClass} mb-4`}>{title}</TitleTag>
      {subtitle && (
        <SubtitleTag className={`text-xl font-bold ${subtitleColorClass}`}>{subtitle}</SubtitleTag>
      )}
    </div>
  );
}
